<template>
  <slot />
</template>

<script setup lang="ts">
import { openChatbox, disableChatWarnings, onChatClose } from '~/helpers/chat';

const props = defineProps<{
  autoOpen?: boolean;
}>();

const isOpen = ref(false);

watch(isOpen, isOpen => {
  if (isOpen) {
    useHead({
      script: [
        {
          src: 'https://client.crisp.chat/l.js',
          defer: true,
          onload: handleLoad
        }
      ]
    });
  }
}, { once: true });

const { crispId } = useBranch();
onBeforeMount(() => {
  if (window.$crisp) return;
  window.$crisp = [];
  window.CRISP_WEBSITE_ID = crispId;
});

onMounted(() => {
  onChatClose(() => isOpen.value = false);
  if (props.autoOpen) open();
});

useEmitter().openChatboxBus.on(open);
useListener('click', 'chat-opener', open);

function open() {
  isOpen.value = true;
  openChatbox();
}

function handleLoad() {
  disableChatWarnings();
  if (isOpen.value) openChatbox();
}
</script>

<style>
#crisp-chatbox a[data-maximized="false"] {
  scale: 0.8;
}

@media (max-width: 850px) {
  #crisp-chatbox a[data-maximized="false"] {
    translate: 10px 10px;
    transition: opacity 250ms !important;
  
    &.hidden {
      opacity: 0;
    }
  }
}
</style>